import { toast } from 'react-toastify';

export const handleAddField = (
  setIsAddingFields: React.Dispatch<React.SetStateAction<boolean>>,
  inputFields: { id: number; value: string }[],
  setInputFields: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>
) => {
  setIsAddingFields(true);
  const lastField = inputFields[inputFields.length - 1];

  if (lastField && lastField.value.trim() !== '') {
      setInputFields([...inputFields, { id: Date.now() + Math.random(), value: '' }]); //NOSONAR
  } else {
      toast.error(
          `The last input field is empty. Please fill it before adding a new one.`,
          {
              position: "bottom-right",
              autoClose: 2500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "toastify-color-error",
          }
      );
      console.log("The last input field is empty. Please fill it before adding a new one.");
  }
};

export const handleFieldChange = (
  inputFields: { id: number; value: string }[],
  setInputFields: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>,
  id: number,
  value: string
) => {
  setInputFields(inputFields.map(field => field.id === id ? { ...field, value } : field));
};

export const handleDeleteField = (
  inputFields: { id: number; value: string }[],
  setInputFields: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>,
  id: number
) => {
  if (inputFields.length > 1) {
      setInputFields(inputFields.filter((field) => field.id !== id));
  }
};

export const handleSaveFields = (
  inputFields: { id: number; value: string }[],
  setRecipientOptions: React.Dispatch<React.SetStateAction<any[]>>,
  setSelectedRecipient: React.Dispatch<React.SetStateAction<any>>,
  selectedRecipient: any,
  handleCancel: (setIsAddingFields: React.Dispatch<React.SetStateAction<boolean>>) => void,
  setIsAddingFields: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const nonEmptyFields = inputFields.filter((field) => field.value.trim() !== '');

  if (nonEmptyFields.length > 0) {
      const options = nonEmptyFields.map((field) => ({
          value: field.value,
          label: field.value,
      }));

      setRecipientOptions(options);

      const isRecipientValid = options.some(option => option.label === selectedRecipient.label);
      let updateRecipient = isRecipientValid ? selectedRecipient : options[0] || null;

      setSelectedRecipient(updateRecipient);
  }

  handleCancel(setIsAddingFields);
};

export const handleCancel = (setIsAddingFields: React.Dispatch<React.SetStateAction<boolean>>) => {
  setIsAddingFields(false);
};

export const handleRecipientChange = (
  setSelectedRecipient: React.Dispatch<React.SetStateAction<any>>,
  e: any
) => {
  setSelectedRecipient(e);
};


export const openSignatureNav = (
    setSignaturesOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setSelectionsOpen: React.Dispatch<React.SetStateAction<boolean>>,
    containerRef: React.RefObject<any>
) => {
    setSelectionsOpen(false);
    if (containerRef.current) {
        containerRef.current.showPropertiesPane = false;
    }
    setSignaturesOpen(true);
};

export const closeSignatureNav = (setSignaturesOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
    setSignaturesOpen(false);
};

export const onDragEnd = (
  result: { destination: any; source: any },
  inputFields: { id: number; value: string }[],
  setInputFields: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>
) => {
  if (!result.destination) return;

  const reorderedFields = reorder(inputFields, result.source.index, result.destination.index);
  setInputFields(reorderedFields);
};

const reorder = (
  list: { id: number; value: string }[],
  startIndex: number,
  endIndex: number
): { id: number; value: string }[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
